import React, { useEffect, useState, useCallback } from 'react'
import DashboardLayout from '../../layoutcontainers/DashboardLayout'
import MaterialBox from '../../components/MaterialBox'
import MaterialTypography from '../../components/MaterialTypography'
import { Tooltip, Grid, Card, CardContent, Box, Stack, Chip, Tabs, Tab, TextField, InputAdornment } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { BASE_URL } from '../Utils/Baseurl'
import { useLoading } from '../../context/loadingcontext'
import MaterialButton from '../../components/MaterialButton'
import SearchIcon from '@mui/icons-material/Search';


const TaskCreationNew = () => {
    const navigate = useNavigate();
    const { setCirleLoading } = useLoading();
    const [sampleProjects, setSampleProjects] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [activeTab, setActiveTab] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalCount, setTotalCount] = useState(0);
    const [nextPage, setNextPage] = useState(null);
    const [prevPage, setPrevPage] = useState(null);


    const fetchProjectsList = useCallback(async () => {
        const token = sessionStorage.getItem("token");
        const user = JSON.parse(sessionStorage.getItem("currentUser"));
        try {
            setCirleLoading(true);
            const response = await axios.post(`${BASE_URL}api/project-list-by-userid/?page_size=${pageSize}&page=${currentPage}`,
                {
                    "user_id": user,
                    "search": searchQuery,
                    "baseline": activeTab === 1 ? 'true' : '',
                },
                {
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": "application/json"
                    }
                }
            );
            setSampleProjects(response.data.data);
            setTotalCount(response.data.count || 0);
            setNextPage(response.data.next_page);
            setPrevPage(response.data.previous_page);
        } catch (error) {
            console.log(error);
        } finally {
            setCirleLoading(false);
        }
    }, [activeTab, currentPage, pageSize, searchQuery, setCirleLoading]);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            fetchProjectsList();
        }, 500);
        return () => clearTimeout(timeoutId);
    }, [fetchProjectsList, searchQuery, activeTab, currentPage, pageSize]);

    const handleNextPage = () => {
        if (nextPage) {
            setCurrentPage(nextPage);
        }
    };

    const handlePrevPage = () => {
        if (prevPage) {
            setCurrentPage(prevPage);
        }
    };

    const totalPages = Math.ceil(totalCount / pageSize);

    const getPageNumbers = () => {
        const pages = [];
        const maxPagesToShow = 5;

        if (totalPages <= maxPagesToShow) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {
            if (currentPage <= 3) {
                for (let i = 1; i <= 4; i++) pages.push(i);
                pages.push('...');
                pages.push(totalPages);
            } else if (currentPage >= totalPages - 2) {
                pages.push(1);
                pages.push('...');
                for (let i = totalPages - 3; i <= totalPages; i++) pages.push(i);
            } else {
                pages.push(1);
                pages.push('...');
                for (let i = currentPage - 1; i <= currentPage + 1; i++) pages.push(i);
                pages.push('...');
                pages.push(totalPages);
            }
        }
        return pages;
    };

    return (
        <DashboardLayout>
            <MaterialBox sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', mb: 2, padding: 1, flexWrap: 'wrap', gap: 2 }}>
                <Box>
                    <MaterialTypography variant='h5' color='dark' fontWeight='bold'>
                        Task Creation
                    </MaterialTypography>
                    <MaterialTypography variant='caption' color='textSecondary'>
                        You can create a list of task based on the project you select.
                    </MaterialTypography>
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 3, flexWrap: 'wrap' }}>
                    <Tabs
                        value={activeTab}
                        onChange={(e, newValue) => setActiveTab(newValue)}
                        sx={{
                            minHeight: '40px',
                            '& .MuiTabs-indicator': {
                                backgroundColor: '#5f6ec2',
                                height: '3px',
                                borderRadius: '3px'
                            },
                            '& .MuiTab-root': {
                                textTransform: 'none',
                                fontWeight: 600,
                                fontSize: '14px',
                                minHeight: '40px',
                                padding: '6px 16px',
                                color: '#666',
                                '&.Mui-selected': {
                                    color: '#5f6ec2'
                                }
                            }
                        }}
                    >
                        <Tab label="All" />
                        <Tab label="Need baseline" />
                    </Tabs>

                    <TextField
                        placeholder="Search project..."
                        size="small"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        sx={{
                            width: '250px',
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '12px',
                                backgroundColor: '#fff',
                                '& fieldset': {
                                    borderColor: 'rgba(0,0,0,0.1)'
                                },
                                '&:hover fieldset': {
                                    borderColor: '#5f6ec2'
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: '#5f6ec2'
                                }
                            }
                        }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon sx={{ color: '#999', fontSize: '20px' }} />
                                </InputAdornment>
                            ),
                        }}
                    />
                </Box>
            </MaterialBox>

            <MaterialBox p={1}>
                <Grid container spacing={2}>
                    {sampleProjects?.map((project) => {
                        const needsRebaseline = project.current_baseline_total_tasks > 0;
                        return (
                            <Grid size={{ xs: 12, sm: 6, md: 2.4, lg: 2.4 }} key={project.project_id}>
                                <Card
                                    sx={{
                                        borderRadius: '20px',
                                        boxShadow: '0 10px 30px rgba(0, 0, 0, 0.05)',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        height: '100%'
                                    }}
                                >
                                    <Box
                                        sx={{
                                            backgroundColor: '#bec7f8ff',
                                            padding: 2,
                                            textAlign: 'left',
                                            borderBottom: '1px solid rgba(0, 0, 0, 0.02)'
                                        }}
                                    >
                                        <Tooltip title={project.project_name || project.projectName || ''}>
                                            <MaterialTypography
                                                variant="h6"
                                                sx={{
                                                    fontSize: '14px',
                                                    fontWeight: 600,
                                                    color: '#333',
                                                    whiteSpace: 'nowrap',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    mb: 1
                                                }}
                                            >
                                                {(project.project_name || project.projectName || 'Untitled Project').length > 18
                                                    ? (project.project_name || project.projectName || 'Untitled Project').substring(0, 18) + '...'
                                                    : (project.project_name || project.projectName || 'Untitled Project')}
                                            </MaterialTypography>
                                        </Tooltip>

                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <Chip
                                                label={needsRebaseline ? 'Needs Rebaseline' : 'Tasks Freezed'}
                                                sx={{
                                                    backgroundColor: needsRebaseline ? '#ef5350' : '#81c784',
                                                    color: '#fff',
                                                    fontWeight: 500,
                                                    fontSize: '11px',
                                                    height: '24px',
                                                    boxShadow: needsRebaseline ? '0 4px 10px rgba(244, 67, 54, 0.2)' : '0 4px 10px rgba(76, 175, 80, 0.2)'
                                                }}
                                            />
                                            <MaterialTypography variant="caption" color="textSecondary" fontWeight="medium">
                                                Baseline: {project.current_baseline_count || 0}
                                            </MaterialTypography>
                                        </Box>
                                    </Box>


                                    <CardContent sx={{ flexGrow: 1, padding: 2 }}>
                                        <Stack spacing={1.5}>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <MaterialTypography variant="body2" color="textSecondary" fontWeight="medium" sx={{ fontSize: '12px' }}>Planned Tasks:</MaterialTypography>
                                                <MaterialTypography variant="body2" color="textPrimary" fontWeight="bold" sx={{ fontSize: '12px' }}>{project.total_initial_tasks || 0} tasks</MaterialTypography>
                                            </Box>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <MaterialTypography variant="body2" color="textSecondary" fontWeight="medium" sx={{ fontSize: '12px' }}>Planned Hours:</MaterialTypography>
                                                <MaterialTypography variant="body2" color="textPrimary" fontWeight="bold" sx={{ fontSize: '12px' }}>{project.total_assigned_hours || 0} hrs</MaterialTypography>
                                            </Box>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <MaterialTypography variant="body2" color="textSecondary" fontWeight="medium" sx={{ fontSize: '12px' }}>Rebaseline Tasks:</MaterialTypography>
                                                <MaterialTypography
                                                    variant="body2"
                                                    fontWeight="bold"
                                                    color={needsRebaseline ? 'error.main' : 'textPrimary'}
                                                    sx={{ fontSize: '12px' }}
                                                >
                                                    {project.current_baseline_total_tasks || 0} tasks
                                                </MaterialTypography>
                                            </Box>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <MaterialTypography variant="body2" color="textSecondary" fontWeight="medium" sx={{ fontSize: '12px' }}>Rebaseline Hours:</MaterialTypography>
                                                <MaterialTypography
                                                    variant="body2"
                                                    fontWeight="bold"
                                                    color={project.current_baseline_hours > 0 ? 'error.main' : 'textPrimary'}
                                                    sx={{ fontSize: '12px' }}
                                                >
                                                    {project.current_baseline_hours || 0} hrs
                                                </MaterialTypography>
                                            </Box>

                                            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <MaterialTypography variant="body2" color="textSecondary" fontWeight="medium" sx={{ fontSize: '12px' }}>Pending by:</MaterialTypography>
                                                <MaterialTypography
                                                    variant="body2"
                                                    fontWeight="bold"
                                                    color={project.current_baseline_hours > 0 ? 'error.main' : 'textPrimary'}
                                                    sx={{ fontSize: '12px' }}
                                                >
                                                   Level {project.blocked_level || 0}
                                                </MaterialTypography>
                                            </Box>
                                        </Stack>
                                    </CardContent>


                                    <Box sx={{ padding: '0 20px 20px 20px' }}>
                                        <MaterialButton
                                            fullWidth
                                            size="small"
                                            variant="contained"
                                            onClick={() => navigate('/task-creation/task-list', { state: { project_id: project.project_id } })}
                                            sx={{
                                                backgroundColor: '#5f6ec2',
                                                color: '#fff',
                                                borderRadius: '12px',
                                                padding: '10px',
                                                textTransform: 'none',
                                                fontWeight: 600,
                                                boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
                                                '&:hover': {
                                                    backgroundColor: '#4a5699',
                                                    transform: 'translateY(-2px)'
                                                }
                                            }}
                                        >
                                            View Task List
                                        </MaterialButton>

                                    </Box>
                                </Card>
                            </Grid>
                        )
                    })}
                </Grid>

                {sampleProjects && sampleProjects.length > 0 && (
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 4, px: 1, flexWrap: 'wrap', gap: 2 }}>
                        <MaterialTypography variant="caption" color="textSecondary" fontWeight="medium">
                            Showing {(currentPage - 1) * pageSize + 1} to {Math.min(currentPage * pageSize, totalCount)} of {totalCount} projects
                        </MaterialTypography>

                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <MaterialTypography variant="caption" color="textSecondary" fontWeight="medium">
                                    Rows per page:
                                </MaterialTypography>
                                <select
                                    value={pageSize}
                                    onChange={(e) => {
                                        setPageSize(Number(e.target.value));
                                        setCurrentPage(1);
                                    }}
                                    style={{
                                        padding: '4px 8px',
                                        borderRadius: '8px',
                                        border: '1px solid rgba(0,0,0,0.1)',
                                        outline: 'none',
                                        fontSize: '12px',
                                        cursor: 'pointer'
                                    }}
                                >
                                    <option value={10}>10</option>
                                    <option value={30}>30</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                </select>
                            </Box>

                            <Box sx={{ display: 'flex', gap: 1 }}>
                                <MaterialButton
                                    size="small"
                                    variant="outlined"
                                    disabled={prevPage === null}
                                    onClick={handlePrevPage}
                                    sx={{ minWidth: '40px', borderRadius: '10px', textTransform: 'none', px: 1 }}
                                >
                                    Previous
                                </MaterialButton>
                                <Box sx={{ display: 'flex', gap: 0.5 }}>
                                    {getPageNumbers().map((page, index) => (
                                        page === '...' ? (
                                            <Box key={`ellipsis-${index}`} sx={{ display: 'flex', alignItems: 'center', px: 1 }}>
                                                <MaterialTypography variant="caption">...</MaterialTypography>
                                            </Box>
                                        ) : (
                                            <MaterialButton
                                                key={page}
                                                size="small"
                                                variant={currentPage === page ? "contained" : "outlined"}
                                                onClick={() => setCurrentPage(page)}
                                                sx={{
                                                    minWidth: '32px',
                                                    height: '32px',
                                                    borderRadius: '8px',
                                                    textTransform: 'none',
                                                    backgroundColor: currentPage === page ? '#5f6ec2' : 'transparent',
                                                    color: currentPage === page ? '#fff' : '#5f6ec2',
                                                    borderColor: '#5f6ec2',
                                                    '&:hover': {
                                                        backgroundColor: currentPage === page ? '#4a5699' : 'rgba(95, 110, 194, 0.04)',
                                                        borderColor: '#5f6ec2'
                                                    }
                                                }}
                                            >
                                                {page}
                                            </MaterialButton>
                                        )
                                    ))}
                                </Box>
                                <MaterialButton
                                    size="small"
                                    variant="outlined"
                                    disabled={nextPage === null}
                                    onClick={handleNextPage}
                                    sx={{ minWidth: '40px', borderRadius: '10px', textTransform: 'none', px: 1 }}
                                >
                                    Next
                                </MaterialButton>
                            </Box>
                        </Box>
                    </Box>
                )}

                {(!sampleProjects || sampleProjects.length === 0) && (
                    <MaterialBox sx={{ textAlign: 'center', mt: 4, color: 'text.secondary' }}>
                        <MaterialTypography variant='body1'>No projects found.</MaterialTypography>
                    </MaterialBox>
                )}
            </MaterialBox>
        </DashboardLayout >
    )
}

export default TaskCreationNew